import { render, staticRenderFns } from "./AppVideoShots.vue?vue&type=template&id=6ef909cc"
import script from "./AppVideoShots.vue?vue&type=script&lang=js"
export * from "./AppVideoShots.vue?vue&type=script&lang=js"
import style0 from "./AppVideoShots.vue?vue&type=style&index=0&id=6ef909cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports